import React, { useEffect, useState } from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'
import ProviderSidebar from '../components/ProviderSidebar'
import { getStoredAppRole } from '../utils/handleCookie'

const APP_THEME_STORAGE_KEY = 'provio_theme'

const DefaultLayout = () => {
  const role = getStoredAppRole()
  const [theme, setTheme] = useState(() => localStorage.getItem(APP_THEME_STORAGE_KEY) || 'dark')
  const isDarkTheme = theme !== 'light'
  const isCallCenterRole = role === 'callcenter'

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    document.body.setAttribute('data-theme', theme)
    document.body.classList.toggle('dark-mode', isDarkTheme)
    document.body.classList.toggle('light-mode', !isDarkTheme)
  }, [theme, isDarkTheme])

  useEffect(() => {
    const syncTheme = () => {
      setTheme(localStorage.getItem(APP_THEME_STORAGE_KEY) || 'dark')
    }

    window.addEventListener('provio-theme-change', syncTheme)
    window.addEventListener('storage', syncTheme)

    return () => {
      window.removeEventListener('provio-theme-change', syncTheme)
      window.removeEventListener('storage', syncTheme)
    }
  }, [])

  return (
    <div className={`theme-shell ${isDarkTheme ? 'theme-shell--dark' : 'theme-shell--light'} theme-layout`} data-theme={theme}>
      {role !== 'provider' && !isCallCenterRole && <AppSidebar />}
      <div className="wrapper d-flex flex-column min-vh-100 theme-layout__wrapper">
        <AppHeader />
        <div className="theme-layout__content">
          {role == 'provider' && <ProviderSidebar />}
          <div className={`body flex-grow-1 p-3 theme-layout__body ${isDarkTheme ? 'body-dark' : 'body-light'}`}>
            <AppContent />
          </div>
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default DefaultLayout
